export default function Radio({ checked, radioColor = '' }) {
  let _radioColor = radioColor || '#FFC75A';
  
  return (
    <div className={'bg-white p-[2px] border flex-none rounded-full mr-[8px] w-[16px] h-[16px] '}
         style={{
           borderColor: checked ? _radioColor : '#bbb'
         }}>
      <i className={`block w-[10px] h-[10px] rounded-full`}
         style={{
           backgroundColor: checked ? _radioColor : '#fff'
         }}/>
    </div>
  );
}
